import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { MessageCircle } from "lucide-react";
import { useLang } from "./LanguageContext";
import { Reveal } from "./Reveal";
import { WA_LINK } from "./content";

export const FAQ = () => {
  const { t } = useLang();

  return (
    <section id="faq" className="relative py-24 md:py-32 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <Reveal>
            <span className="text-xs font-bold tracking-[0.25em] uppercase text-[#ccff00]">
              {t.faq.overline}
            </span>
            <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tight text-white mt-4 leading-tight">
              {t.faq.title}
            </h2>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="faq-whatsapp-btn"
              className="group mt-8 inline-flex items-center gap-3 h-12 px-6 border border-white/15 text-white hover:border-[#ccff00] hover:text-[#ccff00] transition-colors text-sm font-medium"
            >
              <MessageCircle className="h-4 w-4 text-[#ccff00]" />
              {t.footer.waLabel}
            </a>
          </Reveal>
        </div>

        <div className="lg:col-span-8">
          <Reveal delay={0.1}>
            <Accordion type="single" collapsible className="w-full" defaultValue="faq-0">
              {t.faq.items.map((item, i) => (
                <AccordionItem
                  key={i}
                  value={`faq-${i}`}
                  data-testid={`faq-item-${i}`}
                  className="border-white/10"
                >
                  <AccordionTrigger className="py-6 text-left font-display font-semibold text-lg md:text-xl text-white hover:no-underline hover:text-[#ccff00] [&[data-state=open]]:text-[#ccff00] transition-colors">
                    {item.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-base text-zinc-400 font-light leading-relaxed">
                    {item.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
